// The chords a song uses. Values are the display names (matching the titles in
// ChordList); keys spell out sharp/flat/over so they stay UPPER_CASE.
export enum CHORD {
	A = 'A',
	A7 = 'A7',
	A_FLAT = 'Ab',
	A_MINOR = 'Am',
	A_MINOR_7 = 'Am7',
	A_MINOR_OVER_G = 'Am/G',
	A_OVER_D = 'A/D',
	A_SUS = 'Asus',
	B = 'B',
	B7 = 'B7',
	B_FLAT = 'Bb',
	B_FLAT_MINOR = 'Bbm',
	B_MINOR = 'Bm',
	B_MINOR_7 = 'Bm7',
	C = 'C',
	C6 = 'C6',
	C7 = 'C7',
	C_ADD9 = 'Cadd9',
	C_MAJ7 = 'Cmaj7',
	C_MAJ9 = 'Cmaj9',
	C_MINOR = 'Cm',
	C_OVER_B = 'C/B',
	C_OVER_E = 'C/E',
	C_OVER_G = 'C/G',
	C_SHARP_MINOR = 'C#m',
	D = 'D',
	D4 = 'D4',
	D7 = 'D7',
	D_FLAT = 'Db',
	D_MINOR = 'Dm',
	D_MINOR_7 = 'Dm7',
	D_MINOR_7_OVER_G = 'Dm7/G',
	D_OVER_F_SHARP = 'D/F#',
	D_SIX_NINE = 'D6/9',
	D_SUS = 'Dsus',
	D_SUS4 = 'Dsus4',
	E = 'E',
	E7 = 'E7',
	E_FLAT = 'Eb',
	E_MINOR = 'Em',
	E_MINOR_7 = 'Em7',
	E_MINOR_9 = 'Em9',
	E_OVER_G_SHARP = 'E/G#',
	F = 'F',
	F9 = 'F9',
	F_ADD_SHARP_11 = 'Fadd#11',
	F_MAJ9 = 'Fmaj9',
	F_MINOR = 'Fm',
	F_SHARP = 'F#',
	F_SHARP_MINOR = 'F#m',
	G = 'G',
	G5 = 'G5',
	G6 = 'G6',
	G7 = 'G7',
	G9 = 'G9',
	G_FLAT = 'Gb',
	G_OVER_B = 'G/B',
	G_OVER_C = 'G/C',
	G_OVER_D = 'G/D',
	G_SHARP = 'G#',
	G_SHARP_MINOR = 'G#m',
	G_SUS2_OVER_B = 'Gsus2/B',
}
